import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./styles.css";
import { supabase } from "./lib/SupabaseClient";

// ✅ Layouts
import Layout from "./components/Layout";
import ExamsProLayout from "./components/ExamsProLayout";
import UtilityLayout from "./components/UtilityLayout"; // (keep if you use it elsewhere)

// ✅ Core
import AuthRoute from "./context/AuthRoute";
import ChatbotWidget from "./components/ChatbotWidget";
import UpdateToast from "./components/UpdateToast";

// ✅ Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Solutions from "./pages/Solutions";
import ExamsPro from "./pages/solutions/ExamsPro";
import Extracta from "./pages/solutions/Extracta";
import SecureIDVPN from "./pages/solutions/SecureIDVPN";
import DactylScan from "./pages/solutions/DactylScan";
import Avaya from "./pages/solutions/Avaya";
import BackgroundCheck from "./pages/BackgroundCheck";
import FAQ from "./pages/FAQ";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Investors from "./pages/Investors";
import Search from "./pages/Search";

// ✅ ExamsPro / Admin Pages
import Dashboard from "./pages/Dashboard";
import TestsPage from "./pages/TestsPage";
import CandidatesList from "./pages/CandidatesList";
import CandidateInvite from "./pages/CandidateInvite";
import ImportCandidatesPage from "./pages/ImportCandidatesPage";
import AssignedCandidatesPage from "./pages/AssignedCandidatesPage";
import TestPreviewPage from "./pages/TestPreview";

// ✅ Candidate Pages
import CandidateLogin from "./pages/CandidateLogin";
import CandidateVerify from "./pages/CandidateVerify";
import CandidateGuard from "./pages/CandidateGuard";
import CandidateTestPage from "./pages/CandidateTestPage";
import CandidateUnauthorized from "./pages/CandidateUnauthorized";
import CandidateNoTest from "./pages/CandidateNoTest";
import CandidateEnroll from "./pages/CandidateEnroll";
import CandidateProfile from "./pages/CandidateProfile";
import CandidateDashboard from "./pages/CandidateDashboard";
import CandidateFaceLogin from "./pages/CandidateFaceLogin";
import CandidateSecureTestPage from "./pages/CandidateSecureTestPage";
import CandidateSummaryPage from "./pages/CandidateSummaryPage";

// ✅ Other Apps / Industries
import ApplicationServices from "./pages/ApplicationServices";
import DataMaintenance from "./pages/DataMaintenance";
import HumanResources from "./pages/HumanResources";
import GovernmentAgencies from "./pages/GovernmentAgencies";
import Education from "./pages/Education";
import HealthCare from "./pages/HealthCare";
import CreativityLab from "./pages/CreativityLab";
import SupportContact from "./pages/SupportContact";
import ExamsProSupport from "./pages/solutions/ExamsProSupport";

// ✅ Auth
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Profile from "./pages/Profile";
import InviteUser from "./pages/InviteUser";


import BuildExams from "./pages/solutions/examspro/BuildExams";
import DeliverExams from "./pages/solutions/examspro/DeliverExams";
import BiometricValidation from "./pages/solutions/examspro/BiometricValidation";
import OfflineDelivery from "./pages/solutions/examspro/OfflineDelivery";
import PerformanceAnalytics from "./pages/solutions/examspro/PerformanceAnalytics"
// 🧩 ExamsPro Services pages
import ExamDesignDevelopment from "./pages/solutions/examspro/ExamDesignDevelopment";
import TestSecurityServices from "./pages/solutions/examspro/TestSecurityServices";
import HelpCenter from "./pages/solutions/examspro/HelpCenter";
import ResourceLibrary from "./pages/solutions/examspro/ResourceLibrary";
import Training from "./pages/solutions/examspro/Training";
import ExamsProFAQ from "./pages/solutions/examspro/FAQ";
import WhySecureID from "./pages/about/WhySecureID";
import DataDeletion from "./pages/DataDeletion";

import SocialAuthModal from "./components/SocialAuthModal";
export default function App() {
    useEffect(() => {
        supabase.auth.onAuthStateChange((event, session) => {
            console.log(event, session);
        });
    }, []);

    return (
        <>
            <Routes>

                {/* 🌐 PUBLIC MARKETING SITE */}
                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/solutions" element={<Solutions />} />
                    <Route path="/solutions/avaya" element={<Avaya />} />
                    <Route path="/solutions/background-check" element={<BackgroundCheck />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/features" element={<Features />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/tests/:id/preview" element={<TestPreviewPage />} />
                    <Route path="/services/application" element={<ApplicationServices />} />
                    <Route path="/services/data" element={<DataMaintenance />} />
                    <Route path="/industries/hr" element={<HumanResources />} />
                    <Route path="/industries/government" element={<GovernmentAgencies />} />
                    <Route path="/industries/education" element={<Education />} />
                    <Route path="/industries/health" element={<HealthCare />} />
                    <Route path="/insights/creativity-lab" element={<CreativityLab />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/investors" element={<Investors />} />
                    <Route path="/search" element={<Search />} />
                </Route>

                {/* 🧭 EXAMSPRO APP (dedicated layout) */}
                <Route element={<ExamsProLayout />}>
                    {/* Marketing / Info under ExamsPro scope */}
                    <Route path="/solutions/examspro" element={<ExamsPro />} />
                    <Route path="/solutions/extracta" element={<Extracta />} />
                    <Route path="/solutions/SecureIDVPN" element={<SecureIDVPN />} />
                    <Route path="/solutions/dactylscan" element={<DactylScan />} />
                    <Route path="/solutions/examspro/support" element={<ExamsProSupport />} />

                    {/* Support */}
                    <Route path="/support/contact" element={<SupportContact />} />

                    {/* Admin / Authenticated Area */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />

                    {/* Admin dashboard routes */}
                    <Route
                        path="/dashboard"
                        element={
                            <AuthRoute>
                                <Dashboard />
                            </AuthRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <AuthRoute>
                                <Profile />
                            </AuthRoute>
                        }
                    />
                    <Route
                        path="/invite"
                        element={
                            <AuthRoute requiredRole="SuperAdmin">
                                <InviteUser />
                            </AuthRoute>
                        }
                    />
                    <Route
                        path="/invite-candidate"
                        element={
                            <AuthRoute requiredRole="ExamAdmin">
                                <CandidateInvite />
                            </AuthRoute>
                        }
                    />
                    <Route path="/tests" element={<TestsPage />} />
                    <Route path="/candidates" element={<CandidatesList />} />
                    <Route path="/import-candidates" element={<ImportCandidatesPage />} />
                    <Route path="/assigned-candidates" element={<AssignedCandidatesPage />} />

                    {/* Candidate flow */}
                    <Route path="/candidate/login" element={<CandidateLogin />} />
                    <Route path="/candidate/verify" element={<CandidateVerify />} />
                    <Route path="/candidate/secure-test" element={<CandidateSecureTestPage />} />
                    <Route
                        path="/candidate/test/:testId"
                        element={
                            <CandidateGuard>
                                <CandidateTestPage />
                            </CandidateGuard>
                        }
                    />
                    <Route path="/candidate/unauthorized" element={<CandidateUnauthorized />} />
                    <Route path="/candidate/notest" element={<CandidateNoTest />} />
                    <Route path="/candidate/enroll" element={<CandidateEnroll />} />
                    <Route path="/candidate/profile" element={<CandidateProfile />} />
                    <Route path="/candidate/face-login" element={<CandidateFaceLogin />} />
                    <Route path="/candidate/dashboard" element={<CandidateDashboard />} />
                    <Route path="/candidate/summary/:testId" element={<CandidateSummaryPage />} />

                </Route>
                {/* Feature pages */}
                <Route path="/solutions/examspro/build" element={<BuildExams />} />
                <Route path="/solutions/examspro/deliver" element={<DeliverExams />} />
                <Route path="/solutions/examspro/biometric" element={<BiometricValidation />} />
                <Route path="/solutions/examspro/offline" element={<OfflineDelivery />} />
                <Route path="/solutions/examspro/analytics" element={<PerformanceAnalytics />} />
                <Route path="/services/exam-design" element={<ExamDesignDevelopment />} />
                <Route path="/services/security" element={<TestSecurityServices />} />
                <Route path="/resources/help" element={<HelpCenter />} />
                <Route path="/resources/library" element={<ResourceLibrary />} />
                <Route path="/resources/training" element={<Training />} />
                <Route path="/resources/faq" element={<ExamsProFAQ />} />
                <Route path="/about/why-secureid" element={<WhySecureID />} />
                <Route path="/delete" element={<DataDeletion />} />
                {/* 🔁 Redirects */}
                <Route path="/home" element={<Navigate to="/" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <SocialAuthModal /> {/* 👈 this listens for the event */}
            {/* 🌍 GLOBAL FLOATING COMPONENTS */}
            <UpdateToast />
            <ChatbotWidget />
        </>
    );
}
